import { useEffect, useState, useContext, useRef} from 'react'
import {  Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import { Config } from '../../inc/Config';
import Ads from "../components/Ads";
import Product from "../components/product/Product";
import Cats from "../components/product/Cats";

import Header from "./Header";
import Footer from "./Footer";

import './css/Home.css'
import MainList from './Elements/MainList';

export default function Home({data}) {

    const { t } = useTranslation();
	const {siteData} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;

    const [tabsSelected, settabsSelected] = useState(0);
    const [cats, setcats] = useState({});
    const [mostProducts, setmostProducts] = useState([]);
    const [ourSelection, setourSelection] = useState([]);
    const [products, setproducts] = useState([]);
    const [loader, setloader] = useState(true);

    
    useEffect(() => {
        if (data?.most_seller?.length) {
            setmostProducts(data?.most_seller);
        }
        if (data?.products?.length) {
            setproducts(data?.products);
        }
    }, [data]);


	return (
		<>
            <Helmet>
                <title>{siteInfo?.website?.title}</title>
                <meta name="description" content={siteInfo?.website?.description} />
                <meta property="og:title" content={siteInfo?.website?.title} />
                <meta property="og:description" content={siteInfo?.website?.description} />
                <meta property="og:image" content={`${Config?.imgUrl}/${siteInfo?.website?.logo[0]}`} />
            </Helmet>

			<Header />

            <MainList data={data?.list} />

            <div className='mainWidth adsBox'>
                {data?.ads?.map((v, k) => {
                    
                    return ( 
                        <Ads v={v} key={k} />
                    );
                })}
            </div>

            {/* {mostProducts?.length ? <div className='mainWidth homeTopProducts mainTop'>

                <div className='titleBox'>
                    <h4>{t("home_title_3")}</h4>
                    <h5>{t("home_sub_3")}<hr /></h5>
                </div>

                <div className='productsBox'>
                    {mostProducts?.map((v, k) => {
                        return (
                            <Product data={v} key={k} />
                        );
                    })}

                </div>
    
            </div>: false}


            
            {!siteInfo?.settings?.our_collection?.val ? 
            <div className='mainWidth homeTopProducts'>

                <div className='titleBox'>
                    <h4>{t("home_title_2")}</h4>
                    <h5>{t("home_sub_2")}<hr /></h5>
                </div>

                <div className='productsBox list5'>
                    {products?.map((v, k) => {
                        return (
                            <Product data={v} key={k} />
                        );
                    })}
                </div>
    
            </div>: false}


            {siteInfo?.settings?.our_collection?.val == 1 ? 
            <>
                {products?.map((v, k) => {
                    
                    return (

                        <div key={k} className='mainWidth homeTopProducts'>

                            <div className='titleBox'>
                                <h4>{v?.cat?.name}</h4>
                                <h5><hr /></h5>
                            </div>

                            <div className='productsBox list5 ' style={{marginTop:5,}}>
                                {v?.products?.map((v2, k2) => {
                                    return (
                                        <Product data={v2} key={k2} />
                                    );
                                })}
                            </div>
                
                        </div>

                    );
                })}
            </>
            : false} */}

            
            <Footer />
		</>
	)
}
